import { Button } from '@sravni/react-design-system';
import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import type { PropsWithChildren } from 'react';

export const OfferButton = ({ children, onClick, className, ...props }: PropsWithChildren<ButtonProps>) => {
  const onClickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Button
      className={className}
      onClick={onClickHandler}
      {...props}
      block
    >
      {children}
    </Button>
  );
};
